import React from 'react'
import { Button } from 'loyal-react'
import PropTypes from 'prop-types'

let confirmationPage = window.location.pathname.substring(
  0,
  window.location.pathname.indexOf('/', 2)
)

const donationPage = () => {
  window.location.href = '/donation'
}
const getButtonDonation = (onClick) => {
  return (
    <div className='col-12 mb-2 justify-content-center align-self-center'>
      <Button
        className='btn btn-sm btn-featured btn-icon'
        text='Fazer uma doação'
        iconName='icon_donation'
        onClick={onClick}
      />
    </div>
  )
}
const getButtonPrint = (onClick) => {
  return (
    <div className='col-12 justify-content-center align-self-center'>
      <Button
        className='btn btn-sm btn-cart btn-icon'
        text='Imprimir Pedido'
        iconName='icon_press'
        onClick={onClick}
      />
      { process.env.REACT_APP_IUPP_ZENDESK_SUPPORT &&
      <div className='mt-2 border-dashed-top border-color-ui-2'>
        <p className='txt-body-sm pt-2'>
          Caso tenha algum problema, <a className='border-color-links color-links txt-body-sm' target='_blank' href={process.env.REACT_APP_IUPP_ZENDESK_SUPPORT}>fale com a gente.</a>
        </p>
      </div>
      }
    </div>
  )
}
const PrintButton = props => {
  return (
    <div className='row px-2 pt-2 d-print-none'>
      {confirmationPage === '/confirmation' && (
        props.campaignHasDonation ? (
          getButtonDonation(donationPage)
        ) : (
          ''
        )
      )}
      {
        getButtonPrint(window.print)
      }
    </div>
  )
}
PrintButton.propTypes = {
  campaignHasDonation: PropTypes.bool
}

export default PrintButton



// WEBPACK FOOTER //
// ./src/features/About/PrintButton.js